'use client';
import { ProjectCarouselType } from '../type';
import { Box, Paper, Stack } from '@mui/material';
import StandardGallery from './../../../gallery/standardGallery';
import { useState } from 'react';
import Tabs from './Tabs';
import Title from './Title';
import RichText from '../../../RichText';

type Props = {
  data: ProjectCarouselType;
};

const DesktopServices = ({ data }: Props) => {
  const { flip, projects, styling } = data;
  const [selected, setSelected] = useState(0);
  const service = projects[selected];
  if (!service) return null;
  const shouldFlip = ['desktop', 'all'].includes(flip!);

  const images =
    service.images
      ?.map(({ after }) => {
        if (!after?.url) return null;
        return {
          url: after.url,
          alt: after.altText,
          thumbnailUrl: after.url,
          blurUrl: after.blurDataUrl,
        };
      })
      .filter(Boolean) || [];
  return (
    <Stack
      direction={shouldFlip ? 'row' : 'row-reverse'}
      spacing={0.25}
      sx={{ justifyContent: 'center', ...styling.sx }}
    >
      <Box
        sx={{
          aspectRatio: 1,
          width: '50%',
        }}
      >
        <StandardGallery images={images as []} />
      </Box>
      <Paper
        elevation={0}
        component={Stack}
        sx={{
          p: 4,
          aspectRatio: 1,
          width: '50%',
        }}
      >
        <Tabs
          selected={selected}
          setSelected={setSelected}
          projects={projects}
        />
        <Title title={service.title} subTitle={service.subtitle} />
        <RichText>{service.description}</RichText>
      </Paper>
    </Stack>
  );
};

export default DesktopServices;
